import numeral from "./numeral.filter";

const numeralModule = angular
  .module("app.filters.numeral", [])
  .filter("numeral", numeral);

export default numeralModule;



// WEBPACK FOOTER //
// ./src/filters/numeral/numeral.module.js